import {auth} from 'firebase'
import axiosInstance from './axios'
import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store';

/**
 * Views
 */
import LoggedInUser from './views/LoggedInUser'
import Login from './views/Login.vue'
import Create from './views/Create'
import Mark from './views/Mark'
import Find from './views/Find'
import Details from './views/Details'
import Reports from './views/Reports'

/**
 * Components
 */
import WelcomePage from "./components/MainContent/WelcomePage";
import AssessMap from "./components/AssessMap";
import MapStartEnd from "./components/MainContent/QuestionCreator2/RouteStartEnd";
import MapPlotRoutes from "./components/MainContent/QuestionCreator2/Routes/RoutePlotter";
import MapPlotComments from "./components/MainContent/QuestionCreator2/MapPlotComments";

import AnswerMap from "./components/MainContent/Marking/AnswerMap";
import AnswerScoring from "./components/MainContent/Marking/AnswerScoring";

import ForgotPassword from "./components/MainContent/ForgotPassword";
import ResetPassword from "./components/MainContent/ResetPassword";
import Register from "./components/Register";


import {creating} from './store/modules/creating'
import {marking} from './store/modules/marking'
import {find} from './store/modules/find'
import {reports} from './store/modules/reports'

import error404 from "@/views/error404.vue";

let hasVisitedIndex = false;
Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/404',
      name: '404',
      component: error404
    },
    {
      path: '/',
      component: LoggedInUser,
      children: [
        {
          path: '/',
          name: 'home',
          component: WelcomePage,
          //redirect: { name: 'WelcomePage'},
          beforeEnter: (to, from, next) => {
            hasVisitedIndex = true;
            auth().onAuthStateChanged(function (user) {
              if (user) {
                if (!store.state.creating)
                  store.registerModule("creating", creating);
                if (!store.state.marking)
                  store.registerModule("marking", marking);
                if (!store.state.find)
                  store.registerModule("find", find);
                if (!store.state.reports)
                  store.registerModule("reports", reports);

                store.commit('auth/SET_FIREBASE_USER', user);
                store.commit('TOGGLE_SIDEBAR', true);
                auth().currentUser.getIdToken(true)
                  .then((idToken) => {
                    //store.commit('auth/SET_FIREBASE_TOKEN', idToken);
                    axiosInstance.defaults.headers.common['tat-token'] = idToken;
                    store.dispatch('fetchQuestions', user.email);
                    store.dispatch('FETCH_USER_DETAILS');
                    store.dispatch('LOG_SESSION', user.email);
                  })
                  .catch(err => {
                    next('/login')
                  });
                next();
              } else {
                next('/login')
              }
            });
          }
        },
        {
          path: '/login',
          name: 'login',
          component: Login,
        },
        {
          path: '/forgot-password',
          component: ForgotPassword,
          name: 'ForgotPassword'
        },
        {
          path: '/reset-password',
          component: ResetPassword,
          name: 'ResetPassword'
        },
        {
          path: '/register',
          component: Register,
          name: 'Register'
        },
        {
          path: '/create',
          name: 'create',
          meta: {
            title: 'Enter a Question Title'
          },
          component: Create,
          beforeEnter: (to, from, next) => {
            store.commit('SET_TASK', 'create');
            next();
          },
          children: [
            {
              name: 'startPoint',
              meta: {
                title: 'Add a start point'
              },
              path: 'start-point',
              component: MapStartEnd,
              beforeEnter: (to, from, next) => {
                console.log("TOGGLE SIDEBAR")
                store.commit('TOGGLE_SIDEBAR', false);
                next();
              }
            },
            {
              name: 'endPoint',
              meta: {
                title: 'Add an end point'
              },
              path: 'end-point',
              component: MapStartEnd
            },
            {
              name: 'routes',
              meta: {
                title: 'Plot routes'
              },
              path: 'routes',
              component: MapPlotRoutes
            },
            {
              name: 'comments',
              meta: {
                title: 'Plot comments'
              },
              path: 'comments',
              component: MapPlotComments
            }]
        },
        {
          path: '/mark',
          name: 'mark',
          component: Mark,
          children: [
            {
              path: 'map',
              component: AnswerMap,
              name: 'AnswerMap',
              beforeEnter: (to, from, next) => {
                store.commit('SET_TASK', 'mark');
                next();
              },
              children: [
                {
                  path: 'scoring',
                  component: AnswerScoring,
                  name: 'AnswerScoring'
                }
              ]
            },
          ]
        },
        {
          path: '/find',
          name: 'find',
          component: Find
        },
        {
          path: '/details',
          name: 'details',
          component: Details
        },
        {
          path: '/reports',
          name: 'reports',
          component: Reports
        },
        {
          path: '/welcome',
          name: 'welcome',
          component: () => import(/* webpackChunkName: "welcome" */ './components/MainContent/WelcomePage.vue')
        },
      ]
    },
    {
      path: '/assess',
      component: AssessMap,
      beforeEnter: (to, from, next) => {
        let params = window.location.search;
        let parsed = new URLSearchParams(params);
        let tryitout = parsed.get('tryitout')
        store.dispatch('ASSESS_CHECK_KEY', {
          key: to.query.user,
          tryitout: tryitout
        }).then(() => {
          store.dispatch('ASSESS_FETCH_QUESTION', {
            startpoint: to.query.start,
            endpoint: to.query.end,
            qid: to.query.linked_id
          }).then(() => {
            next();
          });
        }).catch((err) => {
          console.log("ERROR")
          console.dir(err);
          next('/404')
        })
      }
    },
    {
      path: '/questionmark',
      name: 'questionmark',
      beforeEnter() {
        let questionMarkID = store.getters.GET_QUESTIONMARK_ID;
        window.open(
          'https://ondemand.questionmark.eu/home/' + questionMarkID + '/',
          '_blank' // open in a new window.
        );
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  console.log(to.path)
  if (to.path === '/assess' || to.path === '/reset-password' | ['/404'].includes(to.path)){
    return next()
  }
  if (!hasVisitedIndex){
    hasVisitedIndex = true
    next('/');
  } else {
    next();
  }
});


export default router
